<template>
  <div class="info-box">
    <div class="head-box">
      <div>
        <p class="p1">{{ $t("user_center.accountManagement") }}</p>
        <p class="mt28 mb38">
          <span class="p2">{{ user.username }}</span>
          <span class="p2 ml40">UID：{{ user.userId }}</span>
        </p>
      </div>
      <div class="btn1" @click="loginOutClick">
        {{ $t("user_center.login_out_text") }}
      </div>
    </div>
    <div>
      <p class="p1 mt40">{{ $t("user_center.securitySettings") }}</p>
      <div class="item-box">
        <div class="c-flex">
          <img src="@/assets/img/images/user/1.png" />
          <div>
            <p class="p3">
              {{ $t("user_center.account_safe.login_password.title") }}
            </p>
            <p class="p4 mt12">***********</p>
          </div>
        </div>
        <div class="btn1" @click="editPasswordClick">
          {{ $t("user_center.account_safe.modify") }}
        </div>
      </div>
      <!-- <div class="item-box">
				<div class="c-flex">
					<img src="@/assets/img/images/user/2.png" />
					<div>
						<p class="p3">{{ $t("user_center.account_safe.phone.title") }}</p>
						<p class="p4 mt12">
							{{ $t("user_center.account_safe.phone.tipsVal") }}
						</p>
					</div>
				</div>
				<div class="item-btn">
					<p :class="[user.phone ? 'p6' : 'p5']">
						{{
						  user.phone ? user.phone : $t("user_center.account_safe.not_bind")
						}}
					</p>
					<div :class="[user.phone ? 'btn2' : 'btn1']" @click="editPhoneClick()">
						{{
						  user.phone
							? $t("user_center.account_safe.modify")
							: $t("user_center.account_safe.bind")
						}}
					</div>
				</div>
			</div> -->
      <div class="item-box">
        <div class="c-flex">
          <img src="@/assets/img/images/user/3.png" />
          <div>
            <p class="p3">{{ $t("user_center.account_safe.email.title") }}</p>
            <p class="p4 mt12">
              {{ $t("user_center.account_safe.email.tipsVal") }}
            </p>
          </div>
        </div>
        <div class="item-btn">
          <p class="p6" :class="[user.email ? 'p5' : 'p5']">
            {{
              user.email ? user.email : $t("user_center.account_safe.not_bind")
            }}
          </p>
          <div :class="[user.email ? 'btn1' : 'btn1']" @click="editEmailClick">
            {{
              user.email
                ? $t("user_center.account_safe.modify")
                : $t("user_center.account_safe.bind")
            }}
          </div>
        </div>
      </div>
      <div class="item-box">
        <div class="c-flex">
          <img src="@/assets/img/images/user/4.png" />
          <div>
            <p class="p3">{{ $t("user_center.account_safe.google.title1") }}</p>
            <p class="p4 mt12">
              {{ $t("user_center.account_safe.google.tipsVal") }}
            </p>
          </div>
        </div>
        <div class="item-btn">
          <p class="p6" :class="[user.statusGoogle === 1 ? 'p6' : 'p5']">
            {{
              user.statusGoogle === 1
                ? ""
                : $t("user_center.account_safe.not_bind")
            }}
          </p>
          <div
            :class="user.statusGoogle === 1 ? 'btn2' : 'btn1'"
            @click="verifyGoogleClick"
          >
            {{
              user.statusGoogle === 1
                ? $t("user_center.account_safe.has_bind")
                : $t("user_center.account_safe.bind")
            }}
          </div>
        </div>
      </div>
      <div class="item-box">
        <div class="c-flex">
          <img src="@/assets/img/images/user/5.png" />
          <div>
            <p class="p3">
              {{ $t("user_center.account_safe.identity.title") }}
            </p>
            <p class="p4 mt12">
              {{ $t("user_center.account_safe.identity.tipsVal") }}
            </p>
          </div>
        </div>
        <div class="item-btn">
          <!-- <p v-if="user.statusKyc === 0" class="p5" style="color: #f04c66">
						{{ $t("user_center.account_safe.not_authenticate") }} 
					</p> -->
          <div
            :class="
              user.statusKyc === 0 || user.statusKyc === 3 ? 'btn1' : 'btn2'
            "
          >
            <span v-if="user.statusKyc === 0" @click="verifyUserClick">
              {{ $t("user_center.account_safe.authenticate") }}
            </span>
            <span v-else-if="user.statusKyc === 1">
              {{ $t("user_center.account_safe.has_authenticate") }}
            </span>
            <span v-else-if="user.statusKyc === 2">
              {{ $t("user_center.account_safe.ing_authenticate") }}
            </span>
            <span v-else-if="user.statusKyc === 3" @click="verifyUserClick">
              {{ $t("user_center.account_safe.fail_authenticate") }}
            </span>
            <!-- <template v-else>
							<span v-if="user.statusKycLevel === 0">
								{{ $t("user_center.account_safe.has_authenticate") }}
							</span>
							<span v-if="user.statusKycLevel === 1">
								{{ $t("user_center.account_safe.has_authenticate") }}
							</span>
							<span v-if-else="user.statusKycLevel === 2">
								{{ $t("user_center.account_safe.ing_authenticate") }}
							</span>
							<span v-if-else="user.statusKycLevel === 3">
								{{ $t("user_center.account_safe.fail_authenticate") }}
							</span>
						</template> -->
          </div>
        </div>
      </div>
      <div class="item-box">
        <div class="c-flex">
          <img src="@/assets/img/images/user/6.png" />
          <div>
            <p class="p3">
              {{ $t("user_center.account_safe.trade_password.title") }}
            </p>
            <p class="p4 mt12">
              {{ $t("user_center.account_safe.trade_password.tip") }}
            </p>
          </div>
        </div>
        <div class="item-btn">
          <div class="btn1" @click="editTradePasswordClick">
            {{
              user.tranPassword === -1
                ? $t("user_center.account_safe.trade_password.btn")
                : $t("user_center.account_safe.modify")
            }}
          </div>
        </div>
      </div>
      <div class="item-box">
        <div class="c-flex">
          <img src="@/assets/img/images/user/7.png" />
          <div>
            <p class="p3">
              {{ $t("user_center.account_safe.authenticate_trade.title") }}
            </p>
            <p class="p4 mt12">
              {{ $t("user_center.account_safe.authenticate_trade.tip") }}
            </p>
          </div>
        </div>
        <div class="item-btn">
          <div class="btn1" @click="tradeVerifyClick">
            {{ $t("user_center.account_safe.trade_password.btn") }}
          </div>
        </div>
      </div>
    </div>
    <EditEmail ref="editEmailRef" />
    <EditPhone ref="editPhoneRef" />
    <TradeVerify ref="tradeVerifyRef" />
    <VerifyGoogle ref="verifyGoogleRef" />
    <EditPassword ref="editPasswordRef" />
    <Authentication ref="AuthenticationRef" />
    <VerifyUser ref="verifyUserRef" />
    <EditTradePassword ref="editTradePasswordRef" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import EditEmail from "@/components/Dialog/EditEmail";
import EditPhone from "@/components/Dialog/EditPhone";
import TradeVerify from "@/components/Dialog/TradeVerify";
import VerifyGoogle from "@/components/Dialog/VerifyGoogle";
import EditPassword from "@/components/Dialog/EditPassword";
import Authentication from "@/components/Dialog/Authentication";
import VerifyUser from "@/components/Dialog/VerifyUser";
import EditTradePassword from "@/components/Dialog/EditTradePassword";
export default {
  components: {
    EditEmail,
    EditPhone,
    TradeVerify,
    VerifyGoogle,
    EditPassword,
    VerifyUser,
    Authentication,
    EditTradePassword,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {};
  },
  methods: {
    loginOutClick() {
      const _this = this;
      const tipsBtn1 = _this.$t("google_bind.confirm");
      const tipsBtn2 = _this.$t("google_bind.cancel");
      this.$confirm(
        _this.$t("tipsVal.logoutTips"),
        _this.$t("user_center.tip"),
        {
          confirmButtonText: tipsBtn1,
          cancelButtonText: tipsBtn2,
          type: "warning",
        },
      )
        .then(() => {
          _this.$store.dispatch("actions_loginOut").then((res) => {
            _this.$router.push({
              path: "/",
            });
          });
        })
        .catch(() => {});
    },
    editPhoneClick() {
      this.$refs.editPhoneRef.title = this.user.phone
        ? this.$t("receipt_money.edit")
        : this.$t("user_center.account_safe.bind");
      this.$refs.editPhoneRef.dialogVisible = true;
    },
    editEmailClick() {
      if (this.user.statusGoogle !== 1) {
        this.$message({
          type: "error",
          message: this.$t("user_center.account_safe.google.tipsVal2"),
        });
        return;
      }

      this.$refs.editEmailRef.title = this.user.email
        ? this.$t("receipt_money.edit")
        : this.$t("user_center.account_safe.bind");
      this.$refs.editEmailRef.dialogVisible = true;
    },
    tradeVerifyClick() {
      this.$refs.tradeVerifyRef.dialogVisible = true;
    },
    verifyUserClick() {
      // this.$message({
      //   type: "warning",
      //   message: "请前往手机端进行认证",
      // });
      this.$refs.verifyUserRef.init();
      // this.$refs.AuthenticationRef.dialogVisible = true;
    },
    checkDetail() {
      this.$confirm(
        this.$t("user_center.account_safe.fail_reason") +
          this.authenticateDesc +
          this.$t("user_center.account_safe.authenticate_again"),
        this.$t("user_center.account_safe.fail_authenticate"),
        {
          confirmButtonText: this.$t("user_center.account_safe.again"),
          cancelButtonText: this.$t("user_center.account_safe.close"),
          type: "info",
        },
      )
        .then(() => {
          this.verifyUserClick();
        })
        .catch(() => {});
    },
    verifyGoogleClick() {
      if (this.user.statusGoogle === 1) return false;
      this.$refs.verifyGoogleRef.dialogVisible = true;
    },
    editPasswordClick() {
      this.$refs.editPasswordRef.dialogVisible = true;
    },
    editTradePasswordClick() {
      // if (this.user.tranPassword === -1) {
      this.$refs.editTradePasswordRef.dialogVisible = true;
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.info-box {
  padding: 40px;
  background: #ffffff;
  border-radius: 22px 22px 22px 22px;
  border: 1px solid var(--border-color);

  .mt28 {
    margin-top: 28px;
  }

  .mb38 {
    margin-bottom: 38px;
  }

  .btn1 {
    width: 112px;
    height: 48px;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    line-height: 48px;
    text-align: center;
    color: var(--white-color);
    background: var(--primary-color);
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
  }

  .btn2 {
    width: 112px;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    background: #eaebed;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
  }

  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 24px;
    color: #333333;
  }

  .p2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #bbbfc4;
  }

  .p3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 16px;
    color: #333333;
  }

  .p4 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    max-width: 520px;
  }

  .p5 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #f04545;
  }

  .p6 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .head-box {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e2e3e3;
  }

  .item-box {
    display: flex;
    margin-top: 32px;
    justify-content: space-between;

    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }

    .item-btn {
      gap: 32px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
